import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { ViewportScroller } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { NavigationService } from '../../../../services/navigation.service';
import { FormService } from '../../../../services/form.service';
import { Router } from '@angular/router';
import { FormGroup, ValidationErrors } from '@angular/forms';
import { AllCaseAttachmentsModel } from 'app/models/all-case-attachments.model';
import { FormRequiredDocumentsMapping } from 'app/constants/document.constants';
import { AlertsService } from 'app/ui-components/alerts/alerts.service';

@Component({
  selector: 'app-agree-submit-button',
  templateUrl: './agree-submit-button.component.html',
  styleUrls: ['./agree-submit-button.component.scss']
})
export class AgreeSubmitButtonComponent implements OnInit, OnDestroy{
  private sizeChangeSubscription!: Subscription;
  private mobileDeviceSize: boolean = false;

  constructor(protected navigationService: NavigationService, protected formService: FormService, private alertService: AlertsService,
    private responsive: BreakpointObserver, protected scroller: ViewportScroller, protected router: Router) { }

  ngOnInit(): void {
    this.sizeChangeSubscription = this.responsive.observe([Breakpoints.Handset]).subscribe(result => {
      if (result.matches) {
        this.mobileDeviceSize = true;
      } else {
        this.mobileDeviceSize = false;
      }
    });

    if(!this.allCaseAttachments && this.formService.getCurrentUsanFormValue()?.get('formType')?.value && this.formService.getCurrentUsanFormValue()?.get('sysId')?.value) {
      this.formService.callFetchAttachmentsForCase().subscribe();
    }
  }

  ngOnDestroy(): void {
    this.sizeChangeSubscription.unsubscribe();
  }

  submitForm() {
    this.formService.submitForm().subscribe(
      result => {
        if(result) {
          this.alertService.displaySuccess("The form was successfully submitted.");
          this.router.navigate(['/usan']);
        } else {
          this.alertService.displayError("There was an error while trying to submit. Please try again.");
        }
      },
      error => {
        console.error(error);
        this.alertService.displayError("There was an error while trying to submit. Please try again.");
      });
  }

  // Just for the form fields and required documents.
  get isFormValid(): boolean {
    return this.isCurrentFormValid;
  }
  
  // For the form fields, required documents, and payment (with proof of payment, if necessary).
  get isReadyForSubmit(): boolean {
    return this.isFormValid && this.isPaymentComplete && this.doesFormHaveProofOfPayment && this.hasAllRequiredDocuments;
  }

  get hasAllRequiredDocuments(): boolean {
    return FormRequiredDocumentsMapping.hasAllRequiredDocumentsAttached(this.formService.getCurrentUsanFormValue().get('formType')?.value, this.allCaseAttachments);
  }

  // For the currentForm FormGroup
  get isCurrentFormValid(): boolean {
    this.formService.getCurrentUsanFormValue().updateValueAndValidity();
    
    let valid = this.currentForm.valid;
    Object.keys(this.formService.getCurrentUsanFormValue().controls).forEach(key => {
      const controlErrors: ValidationErrors | null | undefined = this.formService.getCurrentUsanFormValue().get(key)?.errors;
      if (controlErrors != null && controlErrors != undefined) {
        valid = false;
      }
    });
    return valid;
  }

  get allCaseAttachments(): AllCaseAttachmentsModel {
    return this.formService.getAllCaseAttachmentsValue();
  }

  get isPaymentComplete(): boolean {
    return this.formService.isPaymentCompleted();
  }
  
  get doesFormHaveProofOfPayment(): boolean {
    return this.formService.doesFormHaveProofOfPayment();
  }

  get isMobileDeviceSize(): boolean {
    return this.mobileDeviceSize;
  }

  get currentForm(): FormGroup {
    return this.formService.getCurrentUsanFormValue();
  }
}
